import { motion } from 'motion/react'
import { SVGProps } from 'react'

interface AnimatedIconProps extends SVGProps<SVGSVGElement> {
	isActive?: boolean
}

export default function AnimatedThreeDotsIcon({ isActive, ...props }: AnimatedIconProps) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.143 13.7143C6.08977 13.7143 6.85728 12.9468 6.85728 12.0001C6.85728 11.0533 6.08977 10.2858 5.143 10.2858C4.19622 10.2858 3.42871 11.0533 3.42871 12.0001C3.42871 12.9468 4.19622 13.7143 5.143 13.7143ZM12 13.7143C12.9468 13.7143 13.7143 12.9468 13.7143 12C13.7143 11.0532 12.9468 10.2857 12 10.2857C11.0532 10.2857 10.2857 11.0532 10.2857 12C10.2857 12.9468 11.0532 13.7143 12 13.7143ZM18.8571 13.7143C19.8039 13.7143 20.5714 12.9468 20.5714 12C20.5714 11.0532 19.8039 10.2857 18.8571 10.2857C17.9104 10.2857 17.1429 11.0532 17.1429 12C17.1429 12.9468 17.9104 13.7143 18.8571 13.7143Z"
					fill="var(--tint-primary)"
				/>
				<motion.path
					d="M5.143 13.7143V14.1429C6.32646 14.1429 7.28585 13.1835 7.28585 12.0001H6.85728H6.42871C6.42871 12.7101 5.85308 13.2858 5.143 13.2858V13.7143ZM6.85728 12.0001H7.28585C7.28585 10.8166 6.32646 9.8572 5.143 9.8572V10.2858V10.7143C5.85308 10.7143 6.42871 11.29 6.42871 12.0001H6.85728ZM5.143 10.2858V9.8572C3.95953 9.8572 3.00014 10.8166 3.00014 12.0001H3.42871H3.85728C3.85728 11.29 4.43292 10.7143 5.143 10.7143V10.2858ZM3.42871 12.0001H3.00014C3.00014 13.1835 3.95953 14.1429 5.143 14.1429V13.7143V13.2858C4.43292 13.2858 3.85728 12.7101 3.85728 12.0001H3.42871ZM12 13.7143V14.1429C13.1835 14.1429 14.1429 13.1835 14.1429 12H13.7143H13.2857C13.2857 12.7101 12.7101 13.2857 12 13.2857V13.7143ZM13.7143 12H14.1429C14.1429 10.8165 13.1835 9.85714 12 9.85714V10.2857V10.7143C12.7101 10.7143 13.2857 11.2899 13.2857 12H13.7143ZM12 10.2857V9.85714C10.8165 9.85714 9.85714 10.8165 9.85714 12H10.2857H10.7143C10.7143 11.2899 11.2899 10.7143 12 10.7143V10.2857ZM10.2857 12H9.85714C9.85714 13.1835 10.8165 14.1429 12 14.1429V13.7143V13.2857C11.2899 13.2857 10.7143 12.7101 10.7143 12H10.2857ZM18.8571 13.7143V14.1429C20.0406 14.1429 21 13.1835 21 12H20.5714H20.1429C20.1429 12.7101 19.5672 13.2857 18.8571 13.2857V13.7143ZM20.5714 12H21C21 10.8165 20.0406 9.85714 18.8571 9.85714V10.2857V10.7143C19.5672 10.7143 20.1429 11.2899 20.1429 12H20.5714ZM18.8571 10.2857V9.85714C17.6737 9.85714 16.7143 10.8165 16.7143 12H17.1429H17.5714C17.5714 11.2899 18.1471 10.7143 18.8571 10.7143V10.2857ZM17.1429 12H16.7143C16.7143 13.1835 17.6737 14.1429 18.8571 14.1429V13.7143V13.2857C18.1471 13.2857 17.5714 12.7101 17.5714 12H17.1429Z"
					fill="rgba(0, 0, 0, 0)"
					animate={{
						fill: isActive ? 'var(--tint-primary)' : 'rgba(0, 0, 0, 0)',
					}}
					transition={{
						duration: 0.2,
					}}
				/>
			</g>
		</svg>
	)
}
